// ─── SelecteurCouleur — palette de pastilles — Core ──────────────
// Grille de couleurs cliquables (✓ sur la sélection). Réutilisable pour la
// garde, les calendriers, les postes de finances, les catégories, etc.
//   <SelecteurCouleur valeur={c} onChange={setC} palette={[...]} />
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

export const PALETTE_DEFAUT = ['#FF6B8A', '#4D8AF0', '#3FB27F', '#F5924F', '#A15CE6', '#2BB6C4', '#E5564E', '#E6B23F'];

export default function SelecteurCouleur({ valeur, onChange, palette = PALETTE_DEFAUT }) {
  return (
    <View style={st.rangee}>
      {palette.map(c => {
        const on = valeur === c;
        return (
          <TouchableOpacity key={c} onPress={() => onChange?.(c)} accessibilityLabel={`Couleur ${c}`}
            style={[st.pastille, { backgroundColor: c }, on && st.pastilleOn]}>
            {on && <Text style={st.check}>✓</Text>}
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const st = StyleSheet.create({
  rangee: { flexDirection: 'row', flexWrap: 'wrap', gap: 10 },
  pastille: { width: 34, height: 34, borderRadius: 999, alignItems: 'center', justifyContent: 'center' },
  pastilleOn: { borderWidth: 3, borderColor: '#111' },
  check: { color: '#fff', fontWeight: '900', fontSize: 15 },
});
